import unimetc from "../../../../assets/images/productos/unimetC/UNIMETC - 1.png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/unimetC/Manteinimiento.png"
import pic2 from "../../../../assets/images/productos/unimetC/Mosaico - UC2.png"
import pic3 from "../../../../assets/images/productos/unimetC/Mosaico - UC3.png"
import pic5 from "../../../../assets/images/productos/unimetC/Mosaico - UC5.jpg"

import { useTranslation } from "react-i18next";

function UnimetC() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2, pic3, pic5]}
      datosTabla1={[
        [t("tensionNominal"), "kV", "17,5"],
        [t("corrienteNominal"), "A", "1.250 / 2.000 / 2.500 / 3.150"],
        [t("corrienteBreveDuracion"), "kA", "25 / 31,5 / 40"],
        [t("corrienteDinamica"), "kA", "63 / 78 / 100"],
        [t("nivelDeAislacion"), "kV", "38"],
        [t("tensionDeImpulso"), "kV", "95"],
        [t("frecuenciaNominal"), "Hz", "50 / 60"],
      ]}
      datosTabla2={[
        [t("alto"), "mm", "750 / 1.000"],
        [t("ancho"), "mm", "2800"],
        [t("profundidad"), "mm", "1.670"],
      ]}
      nombreProducto={"Unimet C"}
      fotoProducto={unimetc}
      descripcionProducto={t("unimetC.titulo_descripcion")}
      caracteristicas={[
        t("unimetC.bullet1"),
        t("unimetC.bullet2"),
        t("unimetC.bullet3"),
        t("unimetC.bullet4"),
        t("unimetC.bullet5"),
        t("unimetC.bullet6"),
        t("unimetC.bullet7"),
        t("unimetC.bullet8")
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20Unimet%20C.pdf'}
    />
  );
}

export default UnimetC;
